import Vue from 'vue'
import TileWMS from 'ol/source/TileWMS'
import ImageWMS from 'ol/source/ImageWMS'
import ImageLayer from 'ol/layer/Image'
import BingMapsSource from 'ol/source/BingMaps'
import VectorSource from 'ol/source/Vector'
import VectorLayer from 'ol/layer/Vector'
import LayerGroup from 'ol/layer/Group'
import GeoJSON from 'ol/format/GeoJSON'
import  {all} from 'ol/loadingstrategy'
import Style from 'ol/style/Style'
import Stroke from 'ol/style/Stroke'
import TextStyle from 'ol/style/Text'
import Fill from 'ol/style/Fill'
import IconStyle from 'ol/style/Icon'
// import CircleStyle from 'ol/style/circle'
import TileLayer from 'ol/layer/Tile'
import XYZ from 'ol/source/XYZ'
import MultiPoint from 'ol/geom/MultiPoint'

import store from '../store'
import series from 'async/series'
import each from 'async/each'
import waterfall from 'async/waterfall'
import xmlQuery from 'xml-query'
import xmlReader from 'xml-reader'
import { hex2rgba } from '../util/misc'
import { zoomByDelta } from '../util/map'
import * as olProj from 'ol/proj'
import uniqBy from 'lodash-es/uniqBy'
import isArray from 'lodash-es/isArray'

let counter = 0

class MapService {
  constructor (map) {
    counter++
    if (counter > 1) {
      throw new Error('Only single instance of map service can exists')
    }
    this.map = map
    store.subscribe((data, state) => {
      if (data.type === 'map/layersLoaded') {
        let persistentLayers = this.extractCustomLayers()
        this.map.setLayerGroup(new LayerGroup())
        this.reinitLayers()
        persistentLayers.forEach(layer => {
          this.map.addLayer(layer)
        })

        let tempLayers = []
        this.walkTree(store.getters['map/layersTree'], (layer) => {
          if (layer.temporal_field) {
            tempLayers.push(layer)
          }
        })
        tempLayers = uniqBy(tempLayers, (arrVal) => arrVal.id)
        store.commit('map/temporalLayers', tempLayers)
      }

      if (data.type.indexOf('layerTreeUpdate') > -1 && store.getters['cmp/all']['layers']['enabled']) {
        this.reinitLayers(true)
      }
    })

    this.styleMap = {}
    this.listeners = {}
    this.interactions = []
  }

  extractCustomLayers () {
    return this.map.getLayers().getArray().filter(layer => layer.get('kegs_id') && layer.get('kegs_id').indexOf && (layer.get('kegs_id').indexOf('_custom_v5') > -1))
  }

  checkVisibility (layer) {
    if (layer['loading']) {
      return
    }
    let exists = this._layerExists(layer)
    if (!exists && layer['checked']) {
      this._createLayer(layer)
      return
    }
    exists && exists.setVisible(layer['checked'])

  }

  _layerExists (layer) {
    return this.map.getLayers().getArray()
      .filter(l => {
        return l.get('kegs_id') === layer['id']
      })[0]
  }

  _createLayer (layer) {
    if (layer['data_type'] === 'wfs') {
      this._createWFSLayer(layer)
    }

    if (layer['data_type'] === 'wms') {
      this._createWMSLayer(layer)
    }
    if (layer['data_type'] === 'base') {
      this._createBaseLayer(layer)
    }
  }

  _createWFSLayer (layer) {
    layer['loading'] = true
    store.dispatch('map/layerState', layer)

    let styleData = {}
    series([
      (clb) => {
        waterfall([
          clbw => {
            Vue.http.get('/api/gs/wfs',
              {
                params: {
                  'service': 'wfs',
                  'request': 'DescribeFeatureType',
                  'version': '1.1.0',
                  'outputFormat': 'application/json',
                  'typeName': layer['name']
                }
              })
              .then(res => {
                clbw(null, res.body)
              }, res => {
                clbw(res)
              })
          },
          (r, clbw) => {
            layer['fields'] = r.featureTypes[0].properties.filter(p => p.type.indexOf('gml') === -1)
            layer['geometryColumn'] = r.featureTypes[0].properties.filter(p => p.type.indexOf('gml') > -1)[0]
            waterfall([
              clbm => {
              // console.log(layer)
              if (layer['style']) {
                styleData['name'] = layer['style']
                let arr_style = layer['style'].split(':')
                styleData['url'] = `workspaces/${arr_style[0]}/styles/${arr_style[1]}.json`
                clbm(null, styleData['url'])
              } else {
                Vue.http.get('/api/gs/rest/layers/' + layer['name'] + '.json')
                  .then(res => {
                    styleData['name'] = res.body.layer.defaultStyle.name
                    styleData['url'] = res.body.layer.defaultStyle.href.split('/rest/')[1]
                    clbm(null, styleData['url'])
                  }, res => {
                    clbm(res)
                  })
              }

              },
              (styleUrl, clbww) => {
                Vue.http.get('/api/gs/rest/' + styleUrl.replace('.json', '.sld'))
                  .then(res => {
                    styleData['sld'] = res.body
                    clbww(null)
                  }, res => {
                    clbww(res)
                  })
              },
              clbww => {
                const ast = xmlReader.parseSync(styleData['sld'])
                const xq = xmlQuery(ast)
                let styles = []
                xq.find('Rule').each(rule => {
                  let ruleObj = xmlQuery(rule)
                  let ruleName = ruleObj.find('Name').eq(0).text()
                  let style = {}
                  let p = [ruleObj.find('Stroke').eq(0).find('CssParameter'), ruleObj.find('Fill').eq(0).find('CssParameter')]
                  p.forEach(s => {
                    s.each(node => {
                      let n = xmlQuery(node)
                      let attr = n.attr('name')
                      let value = n.text()
                      style[attr] = value
                    })
                  })

                  let filterFn = () => true
                  let pName = ruleObj.find('ogc:PropertyName').eq(0).text()
                  let equalOp = ruleObj.find('ogc:PropertyIsEqualTo').eq(0).text()
                  let isNullOp = ruleObj.find('ogc:PropertyIsNull').eq(0).text()
                  let isGreaterOp = ruleObj.find('ogc:PropertyIsGreaterThan').eq(0).text()
                  let literal = ruleObj.find('ogc:Literal').eq(0).text()
                  if (pName && literal) {
                    if (equalOp) {
                      filterFn = feature => {
                        return feature.get(pName) + '' === literal + ''
                      }
                    }
                    if (isGreaterOp) {
                      filterFn = feature => {
                        return feature.get(pName) > parseFloat(literal)
                      }
                    }
                  }
                  if (isNullOp && pName) {
                    filterFn = feature => {
                      return feature.get(pName) === null || feature.get(pName) === undefined
                    }
                  }
                  styles.push({
                    style: this._rawStyleToOl(style, layer['name'], ruleName),
                    filter: filterFn
                  })
                })
                this.styleMap[layer['id']] = styles

                if (layer['definedStyle']) {
                  styleData['styleFn'] = layer['definedStyle']
                } else {
                  styleData['styleFn'] = this._getStyleFn(styles)
                }
                clbww(null)
              }
            ], clbw)
          }
        ], clb)
      }
    ], (err, res) => {
      if (err) {
        console.error(err)
      } else {
        let vectorSource = this._getVectorSource(layer)
        vectorSource.on('change', () => {
          layer['loading'] = false
          if (layer['onLoadCallback']) {
            layer['onLoadCallback'].call(this)
          }
          store.dispatch('map/layerState', layer)
          // console.log(`loaded: ${layer.name}`)
          // console.log(`zoom_to_onload: ${layer.zoom_to_onload}`)
          if (layer.zoom_to_onload) {
            console.log(`zooming to layer on load: ${layer.name}`)
            this.zoomToLayer(layer)
          }
        })

        let vector = new VectorLayer({
          source: vectorSource,
          style: styleData['styleFn'] || styleData['style']
        })

        vector.set('kegs_id', layer['id'])
        vector.set('kegs_name', layer['name'])
        vector.set('kegs_title', layer['title'])
        vector.setZIndex(layer['ind'])
        this.map.addLayer(vector)
      }
    })
  }

  _getVectorSource (layer) {
    let cql = layer['cql_custom'] || layer['cql']
    let bbox = store.getters['map/scopeAOI']
    if (bbox && layer['geometryColumn']) {
      let b = `BBOX(${layer['geometryColumn']['name']}, ${bbox}, 'EPSG:3857')`
      if (!cql) {
        cql = b
      } else {
        cql = `${cql} and ${b}`
      }

    }
    // console.log(`${layer.name} -> ${layer.geomfield}`)
    return new VectorSource({
      format: new GeoJSON({
        geometryName: layer.geomfield || 'geo'
      }),
      url: function (extent) {
        return '/api/gs/wfs?service=WFS&' +
          'version=1.1.0&request=GetFeature&typename=' + layer['name'] + '&' +
          'outputFormat=application/json&srsname=EPSG:3857&' +
          ((layer['cql_custom'] || layer['cql']) ? '&cql_filter=' + cql : '')
      },
      strategy: all
    })
  }

  _getStyleFn (styles, label) {
    return (feature, resolution) => {
      let style = styles.filter(st => st.filter(feature, resolution)).map(st => st.style)
      if (style.length && label) {
        style[0].getText().setText(this._composeLabel(feature, label))
      }
      if (style.length && !label) {
        style[0].getText().setText('')
      }
      return style
    }
  }

  _composeLabel (feature, label) {
    let fieldNames
    if (isArray(label)) {
      fieldNames = label.map(l => l.name || l)
    } else {
      fieldNames = [label.name || label]
    }

    return fieldNames.map(f => feature.get(f) + '').join(' ')
  }

  _createWMSLayer (layer) {
    let source
    let layerWms
    let params = {
      url: '/api/gs/wms',
      params: {
        'LAYERS': layer['name'],
        VERSION: '1.1.1',
        format: 'image/png',
        transparent: true,
        cql_filter: layer['cql_custom'] || layer['cql'] || undefined,
        ts: new Date().getTime()
      },
      serverType: 'geoserver'
    }

    if (layer['markers'] && layer['markers'].indexOf('single_image') > -1) {
      source = new ImageWMS(params)
      layerWms = new ImageLayer({
        source: source
      })

      source.on('tileloadstart', () => {
        layer['loading'] = true
        store.dispatch('map/layerState', layer)
      })
      source.on('tileloadend', () => {
        layer['loading'] = false
        store.dispatch('map/layerState', layer)
      })
      source.on('tileloaderror', () => {
        layer['loading'] = false
        store.dispatch('map/layerState', layer)
      })
    } else {
      params.params['TILED'] = true
      source = new TileWMS(params)
      layerWms = new TileLayer({
        source: source
      })

      source.on('imageloadstart', () => {
        layer['loading'] = true
        store.dispatch('map/layerState', layer)
      })
      source.on('imageloadend', () => {
        layer['loading'] = false
        store.dispatch('map/layerState', layer)
      })
      source.on('imageloaderror', () => {
        layer['loading'] = false
        store.dispatch('map/layerState', layer)
      })
    }

    layerWms.set('kegs_id', layer['id'])
    layerWms.set('kegs_name', layer['name'])
    layerWms.set('kegs_title', layer['title'])

    this.map.addLayer(layerWms)
  }

  _createBaseLayer (layer) {
    let source
    if (layer['name'].toLowerCase() === 'osm') {
      source = new XYZ({
        url: 'https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png'
      })
    }
    else if (layer['name'].toLowerCase() === 'otm') {
      source = new XYZ({
        url: 'https://{a-c}.tile.opentopomap.org/{z}/{x}/{y}.png'
      })
    }
    else if (layer['name'].toLowerCase() === 'qldmap_topo') {
      source = new XYZ({
        url: 'https://gisservices.information.qld.gov.au/arcgis/rest/services/Basemaps/QldMap_Topo/MapServer/tile/{z}/{y}/{x}'
      })
    }
     else if (layer['name'].toLowerCase().indexOf('bing') > -1) {
      source = new BingMapsSource({
        key: 'AjrrnvhvWTd7Anm2MOo9NYv5A_FBbnYV2ErFK0hpwTYdqzCSNvDL4X2n4ZXEo4EN',
        imagerySet: layer['name'].split(' ')[1]
      })
    } else {
      console.error('base layer ' + layer['name'] + ' not supported')
      return
    }
    let baseLayer = new TileLayer({
      source: source
    })
    baseLayer.set('kegs_id', layer['id'])
    baseLayer.set('kegs_name', layer['name'])
    baseLayer.set('kegs_title', layer['title'])

    // source.on('tileloadstart', () => {
    //   layer['loading'] = true
    //   store.dispatch('map/layerState', layer)
    // })
    // source.on('tileloadend', () => {
    //   layer['loading'] = false
    //   store.dispatch('map/layerState', layer)
    // })
    // source.on('tileloaderror', () => {
    //   layer['loading'] = false
    //   store.dispatch('map/layerState', layer)
    // })

    this.map.addLayer(baseLayer)
  }

  reinitLayers (clean) {
    let tree = store.getters['map/layersTree']
    let pLayers = store.getters['map/permaLayers']
    let pLabels = store.getters['map/permaLabels']
    let pProfile = store.getters['map/permaProfile']
    if (pLayers) {
      this.walkTree(tree, layer => {
        if (pLayers[layer.name]) {
          layer.checked = true
        } else {
          layer.checked = false
        }
      })
    }
    if (pLabels) {
      Object.keys(pLabels).forEach(k => {
        let layer = null
        this.walkTree(tree, l => {
          if (k === l['name']) {
            layer = l
          }
        })
        pLabels[k].forEach(label => {
          this.setLayerLabel(layer, label)
          store.commit('map/setLayerLabel', [k, label])
        })
      })
    }
    if (store.getters['map/designotron']['enabled'] || store.getters['project/dashboardEnabled'] || clean) {
      this.walkTree(tree, node => {
        this.checkVisibility({...node})
      })
    } else {
      this.walkTree(tree, node => {
        if (localStorage.getItem('layer_tool_' + store.getters['project/currentProject'].workpack.id + '_' + node['name']) == 'true') {
          node.checked = true
        } else if (localStorage.getItem('layer_tool_' + store.getters['project/currentProject'].workpack.id + '_' + node['name']) == 'false') {
          node.checked = false
        }
        this.checkVisibility({...node})
      })
    }

    this.sortLayers()
    if (pProfile) {
      store.commit('map/context_centreline', pProfile)
      store.commit('map/profileShow', true)
    }
  }

  sortLayers () {
    let tree = store.getters['map/layersTree']
    this.walkTreeRev(tree, node => {
      let exists = this._layerExists(node)
      if (exists) {
        this.map.removeLayer(exists)
        this.map.addLayer(exists)
      }
    })

    store.commit('map/layersSorted', new Date().getTime())
  }

  walkTree (tree, fn) {
    let walk = (node) => {
      if (node['children']) {
        node['children'].forEach(n => walk(n))
        return
      }
      fn(node)
    }
    tree.forEach(walk)
  }

  walkTreeRev (tree, fn) {
    let data = [...tree].reverse()
    let walk = (node) => {
      if (node['children']) {
        let ch = [...node['children']].reverse()
        ch.forEach(n => walk(n))
        return
      }
      fn(node)
    }
    data.forEach(walk)
  }

  _rawStyleToOl (styleObj, layerName, ruleName) {
    let style = {
      radius: 5,
      text: new TextStyle({
        text: '',
        font: '13px Arial,sans-serif',
        fill: new Fill({color: hex2rgba('#000000', 1)}),
        stroke: new Stroke({
          color: hex2rgba('#FFFFFF', 1),
          width: 1
        }),
        offsetY: 15,
        offsetX: 15,
        overflow: true
      })
    }
    if (styleObj['stroke']) {
      style['stroke'] = new Stroke({
        color: hex2rgba(styleObj['stroke'], 1),
        width: styleObj['stroke-width'] ? parseFloat(styleObj['stroke-width']) : 1.25
      })
    }
    if (styleObj['fill']) {
      style['fill'] = new Fill({
        color: hex2rgba(styleObj['fill'], styleObj['fill-opacity'] ? parseFloat(styleObj['fill-opacity']) : 1)
      })
    }
    style['image'] = new IconStyle({
      src: '/api/gs/wms?REQUEST=GetLegendGraphic&VERSION=1.0.0&TRANSPARENT=true&FORMAT=image/png&WIDTH=16&HEIGHT=16&LAYER=' + layerName + (ruleName ? '&RULE=' + ruleName : '')
    })

    return new Style(style)
  }

  toggleLayerLegend (layer) {
    store.commit('map/toggleLegend', {
      id: layer['id'],
      name: layer['title'],
      src: '/api/gs/wms?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&TRANSPARENT=true&LAYER=' + layer['name']
    })
  }

  zoomIn () {
    zoomByDelta(this.map, 1)
  }

  zoomOut () {
    zoomByDelta(this.map, -1)
  }

  getVisibleTileLayers () {
    return this.map.getLayers().getArray().filter(layer => (layer.getSource() instanceof TileWMS || layer.getSource() instanceof ImageWMS) && layer.getVisible())
  }

  loadCostSurfaceInfo (workpack_id, geom, node, callback) {
    Vue.http.get('/api/layers/cost-surface-info', {
      params: {
        workpack_id: workpack_id,
        geom: geom
      }
    }).then(res => {
      let b = res.body

      if (b.value) {
        node.children.push({
          key: 'cost',
          value: b.value,
          name: 'Total computed value'
        })
      }

      b.info.forEach(i => {
        node.children.push({
          key: 'cost',
          value: i['cost'],
          name: i['name'],
          meaning: i['meaning'],
          description: i['description']
        })
      })
      node.loading = false
      callback && callback.call(this, node)
      // store.commit('map/infoLayerTree', node)
    }, r => {
      console.log('Getting Cost Surface Info Failed')
      console.error(r)
    })
  }

  loadWmsFeatureInfo (rootWms, bbox, pixel, currentWorkpackId, callback) {
    // TODO: clean
    each(rootWms.children, (node, clb) => {
      node.loading = true
      store.commit('map/infoLayerTree', rootWms)
      Vue.http.get('/api/gs/wfs', {
        params: {
          'service': 'wfs',
          'version': '1.1.0',
          'request': 'GetFeature',
          'typeNames': node.name,
          'srsName': 'EPSG:3857',
          'outputFormat': 'application/json',
          'bbox': bbox.join(',') + ',EPSG:3857'
        }
      })
        .then(res => {
          if (res.bodyText.slice(0, 30).indexOf('ExceptionReport') > -1) {
            let win_bbox = this.map.getView().calculateExtent(this.map.getSize())

            let w = $( '#map' ).width()
            let h = $( '#map' ).height()

            Vue.http.get('/api/gs/wms', {
              params: {
                'service': 'wms',
                'version': '1.1.0',
                'request': 'GetFeatureInfo',
                'layers': node.name,
                'styles':  'raster',
                'srs': 'EPSG:3857',
                'bbox': win_bbox.join(',') + ',EPSG:3857',
                'x': pixel[0],
                'y': pixel[1],
                'query_layers': node.name,
                'info_format': 'application/json',
                'width': w,
                'height': h
              }
            }).then(res => {
              if (res.bodyText.slice(0, 30).indexOf('ExceptionReport') > -1) {
                node.loading = false
                store.commit('map/infoLayerTree', rootWms)
                clb(res.bodyText)
                return
              }
              // filter features to current workpack
              // this probably shouldnt be done on the client
              let resFiltered = res.body.features.filter(f => !f['properties']['workpack_id'] || (f['properties']['workpack_id'] && f['properties']['workpack_id'] === currentWorkpackId))

              node.children = resFiltered.slice(0, 50).map(f => {
                let props = f.properties
                if (!props['name'] && !props['id'] && !props['gid']) {
                  for (let k in props) {
                    if (props.hasOwnProperty(k) && k.indexOf('id') > -1) {
                      props['id'] = props[k]
                    }
                  }
                }
                if (!props['id'] && f.id) {
                  // WORKAROUND for properties not including any form of ID
                  props['id'] = f.id
                }
                // some rasters have no ids or names create name from first value
                if (!props['id'] && !props['name']) {
                  props['name'] = props[Object.keys(props)[0]]
                  if (!isNaN(parseFloat(props['name']))) {
                    props['name'] = parseFloat(props['name']).toFixed(2);
                  }
                }
                return props
              })
              node.loading = false
              callback && callback.call(this, rootWms)
              // store.commit('map/infoLayerTree', rootWms)
              clb(null)
            })
          } else {
            // filter features to current workpack
            // this probably shouldnt be done on the client
            let resFiltered = res.body.features.filter(f => !f['properties']['workpack_id'] || (f['properties']['workpack_id'] && f['properties']['workpack_id'] === currentWorkpackId))
            node.children = resFiltered.slice(0, 50).map(f => {
              let props = f.properties
              if (!props['name'] && !props['id'] && !props['gid']) {
                for (let k in props) {
                  if (props.hasOwnProperty(k) && k.indexOf('id') > -1) {
                    props['id'] = props[k]
                  }
                }
              }
              if (!props['id'] && f.id) {
                // WORKAROUND for properties not including any form of ID
                props['id'] = f.id
              }
              return props
            })
            node.loading = false
            callback && callback.call(this, rootWms)
            // store.commit('map/infoLayerTree', rootWms)
            clb(null)
          }
        }, res => {
          clb(res)
        })
    }, (err) => {
      err && console.error(err)
    })
  }

  forceCreateLayer (layer) {
    layer['checked'] = true
    let exists = this._layerExists(layer)
    if (exists) {
      this.map.removeLayer(exists)
    }
    this.checkVisibility(layer)
    this.sortLayers()
  }

  zoomToLayer (layer) {
    // apiLayers.loadLayerBoundingBox(layer, (err, response) => {
    //   if (err) {
    //     console.error(err)
    //   } else {
    //     try {
    //       const ast = xmlReader.parseSync(response)
    //       const xq = xmlQuery(ast)
    //       let lc = xq.find('ows:LowerCorner').eq(0).text().split(' ').map(n => parseFloat(n))
    //       let uc = xq.find('ows:UpperCorner').eq(0).text().split(' ').map(n => parseFloat(n))
    //       let extent = [lc[0], lc[1], uc[0], uc[1]]
    //       console.log(extent)
    //       console.log(this._layerExists(layer).getSource().getExtent())
    //       this.map.getView().fit(extent, {
    //         padding: [10, 10, 10, 10]
    //       })
    //     } catch (e) {
    //
    //     }
    //   }
    // })
    if (layer['data_type'] === 'wfs') {
      let l = this._layerExists(layer)
      if (l) {
        if (!l.getSource().getFeatures().length) {
          console.log('no features in layer')
          return
        }
        this.map.getView().fit(l.getSource().getExtent(), {
          padding: [10, 10, 10, 10]
        })
      } else {
        layer['checked'] = true
        layer['onLoadCallback'] = () => {
          console.log('calling zoom to')
          this.zoomToLayer(layer)
        }
        this.checkVisibility(layer)
      }
    } else if (layer['data_type'] === 'wms') {
      let lc = layer['gs']['bbox']['lc'].split(' ').map(n => parseFloat(n))
      let uc = layer['gs']['bbox']['uc'].split(' ').map(n => parseFloat(n))
      let geom = new MultiPoint([lc, uc]).transform(olProj.get('EPSG:4326'), olProj.get('EPSG:3857'))
      let bbox = geom.getExtent()
      this.map.getView().fit(bbox, {
        padding: [10, 10, 10, 10]
      })
    }
  }

  zoomToGeom (geom) {
    this.map.getView().fit(geom, {
      padding: [50, 50, 50, 50],
      maxZoom: 16
    })
  }

  getLayersToZoom () {
    // TODO: move this to config
    let names = ['v4:centreline', 'v4:vw_well']
    if (store.getters['project/dashboardEnabled']) {
      names.push('v4:aor')
    }
    let layers = []
    this.walkTree(store.getters['map/layersTree'], node => {
      if (names.indexOf(node['name']) > -1 && node['data_type'] === 'wfs') {
        layers.push(node)
      }
    })
    return layers
  }

  setLayerLabel (layer, label) {
    let exists = this._layerExists(layer)
    if (exists) {
      exists.setStyle(this._getStyleFn(this.styleMap[layer['id']], label))
    }
  }

  addListener (name, handler, scope) {
    if (!this.listeners[name]) {
      this.listeners[name] = []
    }

    this.listeners[name].forEach(o => {
      this.disableListener(name, o.handler)
    })

    this.listeners[name].push({
      handler: handler,
      scope: scope
    })
    this.map.on(name, handler, scope)

    this.interactions.forEach(i => i.setActive(false))

  }

  removeListener (name, handler, scope) {
    let index = this.listeners[name].map(o => handler).indexOf(handler)
    if (this.listeners[name] && index > -1) {
      this.listeners[name].forEach(o => {
        this.disableListener(name, o.handler, o.scope)
      })

      this.listeners[name].splice(index, 1)

      this.listeners[name].length && this.enabledListener(name, this.listeners[name][this.listeners[name].length - 1])
    }

    if (this.listeners['click'] && !this.listeners['click'].length) {
      this.interactions.forEach(i => i.setActive(true))
    }
  }

  enabledListener (name, handler, scope) {
    this.map.on(name, handler, scope)
  }

  disableListener (name, handler, scope) {
    this.map.un(name, handler, scope)
  }

  hasActiveListeners () {
    for (let k in this.listeners) {
      if (this.listeners.hasOwnProperty(k) && this.listeners[k].length > 0) {
        return true
      }
    }

    return false
  }

  disableAllListeners () {
    for (let k in this.listeners) {
      if (this.listeners.hasOwnProperty(k) && this.listeners[k].length > 0) {
        this.listeners[k].forEach(o => {
          this.disableListener(k, o.handler, o.scope)
        })
      }
    }
  }

  addInteraction (i) {
    let index = this.interactions.indexOf(i)
    if (index > -1) {
      return
    }

    // BELOW COMMENTED TO ENABLE SELECT & DRAG
    // this.interactions.forEach(i => i.setActive(false))
    this.interactions.push(i)
    this.map.addInteraction(i)
    this.disableAllListeners()
  }

  removeInteraction (i) {
    let index = this.interactions.indexOf(i)
    if (index === -1) {
      return
    }
    this.map.removeInteraction(this.interactions[index])
    this.interactions.splice(index, 1)

    if (this.interactions.length) {
      this.interactions[this.interactions.length - 1].setActive(true)
    }

    if (!this.interactions.length && this.listeners['click'] && this.listeners['click'].length) {
      this.listeners['click'].forEach(l => {
        this.enabledListener('click', l.handler, l.scope)
      })
    }
  }

  toWfs() {
    let pool = []
    this.walkTree(store.getters['map/layersTree'], node => {
      if (node['transformable'] && node['data_type'] === 'wms') {
        node['data_type'] = 'wfs'
        pool.push(node)
      }
    })

    return pool
  }

  toWms() {
    let pool = []
    this.walkTree(store.getters['map/layersTree'], node => {
      if (node['transformable'] && node['data_type'] === 'wfs') {
        node['data_type'] = 'wms'
        pool.push(node)
      }
    })

    return pool
  }

}

export default MapService



// WEBPACK FOOTER //
// ./src/service/map.js